import { z } from 'zod';

export const PlanType = z.string();

export type PlanType = z.infer<typeof PlanType>;
